import fr_FR from 'antd/lib/locale/fr_FR';
import saMessages from '../locales/fr_FR.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  antd: fr_FR,
  locale: 'fr-FR',
};
export default saLang;
